"use strict";

var CSS_STYLE = '<link rel="stylesheet" href="/styles/components/components.css">';

function dokivPrint() {
  return {
    restrict: "A",
    scope: {
      id: "@dokivPrint"
    },
    link: function(scope, el) {

      var iframe = document.createElement("iframe");

      iframe.setAttribute("style", "height: 0; width: 0; position: absolute; bottom: 100%; right: 100%;");

      document.body.appendChild(iframe);

      el.bind("click", function() {
        var toPrint = $(scope.id)[0];
        var win     = iframe.contentWindow;

        win.document.open();
        win.document.write(CSS_STYLE);
        win.document.write(toPrint.innerHTML);
        win.document.close();

        win.focus();

        setTimeout(function() {
          win.print();
        }, 200);
      });

      scope.$on("$destroy", function() {
        iframe.remove();
      });
    }
  };
}

angular.module("dokiv")
  .directive("dokivPrint", dokivPrint);



//////////////////
// WEBPACK FOOTER
// ./scripts/app/DokivPrint.js
// module id = 240
// module chunks = 0